import { faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { Button } from "react-bootstrap";
import { CONTACT_PATH } from "../../nav/NavigationItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import React from "react";
import { faAt } from "@fortawesome/free-solid-svg-icons";

const SocialLinks = () => {
  return (
    <aside>
      <div className="social-link">
        <Link to={CONTACT_PATH}>
          <Button>
            <FontAwesomeIcon icon={faAt} style={{ maxHeight: "42px" }} />
          </Button>
        </Link>
      </div>
      {/*
      <div className="social-link">
        <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
          <Button>
            <FontAwesomeIcon
              icon={faLinkedinIn}
              style={{ maxHeight: "42px" }}
            />
          </Button>
        </a>
      </div>
      */}
      <div className="social-link">
        <a
          href="https://www.instagram.com/new.space_kassel/"
          target="_blank"
          rel="noreferrer"
        >
          <Button>
            <FontAwesomeIcon icon={faInstagram} style={{ maxHeight: "42px" }} />
          </Button>
        </a>
      </div>
    </aside>
  );
};

export default SocialLinks;
